/**
 * 「行がまだ無い」（エラーではなく、結果が空）のときだけ、短く待って取り直す（指示書 A-24）。
 *
 * ログイン直後は、プロフィール行の作成（saveUserProfile）とルーターのガードの読み込みが同時に走る。
 * 以前は固定の1秒待機でこの競合を隠していた。待機をなくしたので、行が無いときだけ、期限付きで取り直す。
 * 取得エラーは取り直さずにそのまま返す（エラーを「行が無い＝未登録」と扱わない）。
 *
 * @template T
 * @param {() => Promise<{ data: T|null, error: any }>} fetchOnce
 * @param {{ attempts?: number, delayMs?: number, sleep?: (ms: number) => Promise<void> }} [opts]
 * @returns {Promise<{ data: T|null, error: any, tries: number }>}
 */
export async function retryWhileMissing(fetchOnce, { attempts = 3, delayMs = 400, sleep = (ms) => new Promise((r) => setTimeout(r, ms)) } = {}) {
  let last = { data: null, error: null }
  for (let i = 1; i <= attempts; i += 1) {
    last = await fetchOnce()
    if (last?.error) return { data: null, error: last.error, tries: i }
    if (last?.data != null) return { data: last.data, error: null, tries: i }
    if (i < attempts) await sleep(delayMs)
  }
  return { data: null, error: null, tries: attempts }
}
